// src/pages/TestimonialsPage.js
import React from 'react';
import Testimonial from '../components/Testimonial';
import Footer from '../components/Footer';
import reviews, { GOOGLE_REVIEW_URL } from '../data/reviews';
import '../styles/TestimonialsPage.css';

const TestimonialsPage = () => {
  const visible = reviews.filter((r) => r.active !== false);

  return (
    <div className="testimonials-page">
      <header className="testimonials-page__header">
        <span className="testimonials-page__eyebrow">What Our Guests Say</span>
        <h1 className="testimonials-page__title">Reviews</h1>
        <hr className="gold-divider gold-divider--center" />
      </header>

      <div className="testimonials-grid">
        {visible.map((t, i) => (
          <Testimonial key={i} {...t} />
        ))}
      </div>

      <div className="testimonials-page__cta">
        <p>Had a great experience? We'd love to hear from you.</p>
        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-gold"
        >
          Leave a Google Review
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;
